import { AxiosError } from 'axios';

/**
 * Detects browser-blocked cross-origin requests and other network failures
 * where no HTTP response is available (typical CORS / connectivity errors).
 */
export const isCorsOrNetworkError = (error: unknown): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (error instanceof AxiosError) {
    return (
      error.response == null && (error.code === 'ERR_NETWORK' || error.message === 'Network Error')
    );
  }

  if (error instanceof TypeError) {
    const message = error.message.toLowerCase();
    return message.includes('failed to fetch') || message.includes('networkerror');
  }

  return false;
};
